import { render, staticRenderFns } from "./CommentUsersList.vue?vue&type=template&id=0b4d508a&scoped=true&"
import script from "./CommentUsersList.vue?vue&type=script&lang=js&"
export * from "./CommentUsersList.vue?vue&type=script&lang=js&"
import style0 from "./CommentUsersList.vue?vue&type=style&index=0&id=0b4d508a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d508a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemGroup,VListItemIcon})
